import React from "react";
import {gray} from "../constants/Colours";

export const Empty = ({ text = "Отсутствуют" }) => <span style={{ color: gray, border: "none", padding: 0 }}>
  {text}
</span>
